import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';

import { FileService } from 'src/app/core/services/file.service';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';

@Component({
    selector: 'app-file-uploader-box',
    templateUrl: './file-uploader-box.component.html',
    styleUrls: ['./file-uploader-box.component.scss'],
    standalone: false
})
export class FileUploaderBoxComponent
  extends FileUploaderComponent
  implements OnInit
{
  //#region properties
  imageUrl: string;
  fileUrl: string;
  allowedFiles: string[] = [
    '.jpg',
    '.jpeg',
    '.png',
    '.mp3',
    '.mp4',
    '.mkv',
    '.pdf',
  ];
  //#endregion

  constructor(
    protected fileService: FileService,
    protected elementRef: ElementRef,
    protected renderer: Renderer2
  ) {
    super(fileService, elementRef, renderer);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.input_placeholder = '';
  }

  //#region drag & drop

  onFileChange(pFileList) {
    this.file = Object.keys(pFileList).map((key) => pFileList[key]);
  }

  onDragOver(event) {
    event.preventDefault();
  }

  onDropSuccess(event) {
    event.preventDefault();
    if (!this.fileService.checkFilesCount(event?.dataTransfer?.files, 1))
      return;

    this.onCheckFiles(event?.dataTransfer.files[0]);
  }
  onCheckFiles(event) {
    if (!event) {
      this.output_value.emit(null);
      return;
    }
    const file = event;
    if (!file) return;

    if (this.fileTypes)
      if (!this.checkFileType(file, this.fileTypes)) {
        this.clearFile();
        return;
      }

    if (!this.checkFileSize(file, this.input_maxFileSize)) {
      this.clearFile();
      return;
    }

    this.file = file;
    this.output_value.emit(file);
    this.getFile(event);
    this.onFileChange(event.dataTransfer.files[0]);
  }
  //#endregion

  //#region set file and get imageUrl

  getFile(file) {
    if (!file) {
      this.imageUrl = '';
      return;
    }
    this.file = file;

    this.onFileChanged(file);
  }

  onFileChanged(file: any) {
    if (file) {
      this.input_formControlName.setErrors(null);
      const reader = new FileReader();

      if (
        file.type == 'image/png' ||
        file.type == 'image/jpeg' ||
        file.type == 'image/jpg'
      )
        reader.onload = (event: any) => {
          this.imageUrl = event.target.result;
          this.fileUrl = null;
        };
      else if (file.type == 'application/pdf') {
        this.fileUrl = 'assets/media/svg/files/pdf.svg';
        this.imageUrl = null;
      } else if (file.type == 'video/mp4' || file.type == 'video/mkv') {
        this.fileUrl = 'assets/media/svg/files/mp4.svg';
        this.imageUrl = null;
      } else if (file.type == 'audio/mpeg' || file.type == 'audio/mp3') {
        this.fileUrl = 'assets/media/svg/files/file.svg';
        this.imageUrl = null;
      }

      reader.readAsDataURL(file);
    }
  }

  //#endregion

  onCheckFile(event) {
    if (!event) {
      this.output_value.emit(null);
      return;
    }

    const file = event?.target?.files[0];

    if (!file) return;

    if (this.fileTypes)
      if (!this.checkFileType(file, this.fileTypes)) {
        this.clearFile();
        return;
      }

    if (!this.checkFileSize(file, this.input_maxFileSize)) {
      this.clearFile();
      return;
    }

    this.file = file;
    this.output_value.emit(file);
    this.getFile(event?.target?.files[0]);
  }

  clearFile() {
    this.file = '';
    this.imageUrl = '';
    this.output_value.emit(null);
    this.output_onClearFile.emit(true);
  }
}
